import { render, staticRenderFns } from "./StakeChimpers.vue?vue&type=template&id=381ee440&scoped=true&"
import script from "./StakeChimpers.vue?vue&type=script&lang=ts&"
export * from "./StakeChimpers.vue?vue&type=script&lang=ts&"
import style0 from "./StakeChimpers.vue?vue&type=style&index=0&id=381ee440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381ee440",
  null
  
)

export default component.exports